export const ROOM_ITEMS = [
    { level: 1, id: "plant", name: "گلدان", emoji: "🪴", metric: "streak", threshold: 3, hint: "سه روز پشت‌سرهم" },
    { level: 2, id: "shelf", name: "قفسهٔ کتاب", emoji: "📚", metric: "streak", threshold: 7, hint: "یک هفته" },
    { level: 3, id: "lamp", name: "چراغ مطالعه", emoji: "💡", metric: "streak", threshold: 14, hint: "دو هفته" },
    { level: 4, id: "poster", name: "پوستر دیوار", emoji: "⭐", metric: "streak", threshold: 30, hint: "یک ماه" },
    { level: 5, id: "chair", name: "صندلی تازه", emoji: "🪑", metric: "study", threshold: 50 * 60, hint: "۵۰ ساعت مطالعه" },
    { level: 6, id: "upgrade", name: "ارتقای کامل اتاق", emoji: "🏠", metric: "study", threshold: 100 * 60, hint: "۱۰۰ ساعت مطالعه" },
];
/**
 * سطح اتاق را از «بیشترین دستاورد تاکنون» حساب می‌کند، نه از وضعیت فعلی —
 * تا شکستن زنجیره باعث پس گرفتن آیتم نشود.
 */
export function roomState(longestStreak, studyMinutes) {
    const reached = (it) => it.metric === "streak" ? longestStreak >= it.threshold : studyMinutes >= it.threshold;
    const unlocked = ROOM_ITEMS.filter(reached);
    const next = ROOM_ITEMS.find((it) => !reached(it));
    let nextProgress = 1;
    let nextRemaining = 0;
    if (next) {
        const have = next.metric === "streak" ? longestStreak : studyMinutes;
        const prev = ROOM_ITEMS.filter((i) => i.metric === next.metric && i.threshold < next.threshold).pop();
        const base = prev ? prev.threshold : 0;
        nextProgress = Math.max(0, Math.min(1, (have - base) / (next.threshold - base)));
        nextRemaining = Math.max(0, next.threshold - have);
    }
    return {
        level: unlocked.length,
        unlocked: unlocked.map((i) => i.id),
        next,
        nextProgress,
        nextRemaining,
    };
}
//# sourceMappingURL=room.js.map